import { useCustomAppContext } from "contexts/CustomAppContext";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const Logo = ({
  onClick,
  className,
  color = "original",
}: {
  onClick?: () => void;
  className?: string;
  color?: "original" | "white";
}) => {
  const { customApp } = useCustomAppContext();

  const customLogo = customApp?.company.logo;

  return customLogo ? (
    <img
      src={customLogo.url}
      alt={customLogo.description || "company logo"}
      className={className}
      onClick={onClick}
      style={{ userSelect: "none", pointerEvents: "none" }}
    />
  ) : (
    <Container>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 63 32"
        height="44"
        className={className}
        onClick={onClick}
      >
        <defs />
        <g fill="none" fillRule="evenodd">
          <rect
            width="63"
            height="32"
            x="-5.5e-7"
            fill={color === "original" ? "#000" : "#FFF"}
            fillRule="nonzero"
            rx="4"
          />
          <path
            fill={color === "original" ? "#FFF" : "#000"}
            d="M13.1891892 9.51351351c1.8926126.00432433 3.4061261.48072072 4.5405405 1.42918919 1.1344144.9484685 1.7585586 2.2284685 1.8724325 3.84h-3.8486487c-.034682-.5941034-.3219211-1.1449729-.7891892-1.5135135-.5455249-.3959525-1.2100042-.5935417-1.8832432-.56-.7279279 0-1.2886487.134054-1.6821622.4021622-.3777754.2463902-.6004682.6713078-.5881081 1.1221621 0 .5347748.2673874.941982.8021622 1.2216216a12.55134618 12.55134618 0 002.4994594.8475676 21.09406506 21.09406506 0 012.8410811.8908108c.7542637.3096982 1.4220441.7979199 1.945946 1.4227027.5448648.6414415.8273873 1.489009.8475675 2.5427027.0109883.8831037-.2551899 1.7474267-.7610811 2.4713514-.5529488.7646667-1.310707 1.3575319-2.1859459 1.7102702-1.0513702.4349595-2.1813569.6477062-3.3189189.6248649-1.205894.0201833-2.4020004-.2194804-3.50702705-.7027027-.96751766-.4186171-1.81272841-1.0763339-2.45621621-1.9113513-.58903895-.7699212-.93462726-1.6982663-.99243243-2.665946h4.04108109c.0759306.6123034.4043986 1.1649762.9059459 1.5243243.5704957.4159885 1.2641251.6284172 1.9697298.6032433.7654054 0 1.3643243-.1535135 1.7967567-.4605406.4044894-.2550941.6494849-.7001692.6486487-1.1783783 0-.5160361-.2637838-.9037838-.7913514-1.1632433a14.84325082 14.84325082 0 00-2.5145946-.8475676 21.2064817 21.2064817 0 01-2.91675674-.8908108c-.75256945-.3065984-1.42009154-.790181-1.94594594-1.4097297-.54630631-.6313513-.81945946-1.483964-.81945946-2.5578378-.00530726-.864187.26091094-1.7082197.76108108-2.412973.55406087-.7673363 1.30997258-1.3660782 2.18378378-1.7297297 1.05717558-.44824024 2.19677268-.66923514 3.34486488-.64864869zm15.9567567 0c1.4163951-.02152393 2.8150592.31698254 4.0648649.98378379C34.390186 11.1305358 35.3594371 12.093776 36 13.2691892c.678099 1.2675765 1.0190933 2.688138.9902703 4.1254054a9.37513748 9.37513748 0 01-.0616223 1.1696132l-.0529723.3871436H25.2367568c.0951351 1.1488288.4972973 2.049009 1.2064864 2.7005405.7118687.6534772 1.6502579 1.0040159 2.6162163.9772973 1.4161024 0 2.4447405-.5756981 3.0859145-1.7270944l.1032746-.1972299h4.3394595c-.4461743 1.5142497-1.3746889 2.8413498-2.6443243 3.7794594-1.3030631.985946-2.9023424 1.4789189-4.7978379 1.4789189-1.4404181.0237722-2.8622012-.3279478-4.1254054-1.0205405-1.206878-.6687484-2.1949353-1.6718218-2.8454054-2.8886486-.7029204-1.3309996-1.0542043-2.8194909-1.0205405-4.3243244-.0306208-1.5076267.3172855-2.9988661 1.0118919-4.3372973.6367377-1.2113983 1.6137529-2.2102085 2.8108108-2.8735135 1.2796961-.68875544 2.7156775-1.03508913 4.1686486-1.00540539zm14.598919-3.67567567V9.7772973h3.5632432v3.3059459h-3.5545946v7.7016217c0 .5383783.1405406.9254054.3891892 1.1654054.2486487.24.6854054.3589189 1.2972973.3589189h1.8681081v3.3924334h-2.5275676c-3.3917117.0014405-5.0875675-1.6468478-5.0875675-4.9448658v-7.6735136h-1.8962162V9.7772973h1.8962162V5.83783784h4.0518919zM29.2638953 12.8245366l-.4733601-.0000024c-.840736.0291804-1.6484821.3475628-2.2845893.9051955-.6223423.5536337-1.0242442 1.3040891-1.2057057 2.2513664l-.044024.2632282h7.5675676c.0143555-.9558655-.3996848-1.8680233-1.1286487-2.4864865-.6225184-.5237102-1.3871918-.8418098-2.1895172-.9178029l-.2417226-.0154983z"
          />
          <path
            fill={color === "original" ? "#E71F3D" : "#000"}
            d="M56.6205474 8.91243243c.002618-1.24958814-.7482112-2.37755353-1.9020116-2.85736813-1.1538004-.4798146-2.4830508-.21686241-3.3672644.66611195-.8842136.88297435-1.1490299 2.21185463-.670834 3.36632685.4781959 1.1544722 1.6051071 1.9068827 2.8546977 1.9060112 1.7040224 0 3.0854123-1.3813838 3.0854123-3.08540619v.00432432z"
          />
        </g>
      </svg>
    </Container>
  );
};

export default Logo;

const Container = styled.div`
  display: flex;
  gap: 7px;
  align-items: flex-end;
`;

const AdminText = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: white;
  text-decoration: none;
  margin-bottom: 6px;
`;
